'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.sub = sub;


/**
 *
 * @param {*} arg
 * @param {*} step
 */
function add(arg, step) {
  var n1 = void 0,
      n2 = void 0;
  if (typeof arg === 'number') {
    return arg + step;
  } else {
    n1 = arg.toString().split('.')[0];
    n2 = arg.toString().split('.')[1];
    return Number((Number(n1) + step).toString() + '.' + n2);
  }
}

/**
 *
 * @param {*} arg
 * @param {*} step
 */
function sub(arg, step) {
  var n1 = void 0,
      n2 = void 0;
  if (typeof arg === 'number') {
    return arg - step;
  } else {
    n1 = arg.toString().split('.')[0];
    n2 = arg.toString().split('.')[1];
    return Number((Number(n1) - step).toString() + '.' + n2);
  }
}